import React from 'react';
import Sidebar from '../components/Sidebar';
import DashboardNavbar from '../components/DashboardNavbar';
import PriceConfigTable from '../components/PriceConfigTable';

const PriceConfig = () => {
  return (
    <div className="d-flex entire-bg-color">
      <Sidebar />

      <div className="flex-grow-1">
        <DashboardNavbar />
        <div style={{ marginTop: '70px' }}></div>

        <PriceConfigTable />
      </div>
    </div>
  );
};

export default PriceConfig;
